<!-- Version 2: Use embedded dashboard component -->
<ng-container>
  <irembogov-report-dashboard
    [activeRole]="activeRole"
    [additionalContext]="extraDashboardUserContext"
    [activeScopeId]="activeScopeId"></irembogov-report-dashboard>
</ng-container>
